import React from 'react';
import { Button } from 'reactstrap';
import { t } from 'i18next';
import UncontrolledTooltip from '../reactstrap/UncontrolledTooltip';

class ButtonActionToggle extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            active: props.active
        }
    }

    render() {
        const { active } = this.state;

        return (
            <React.Fragment>
                <Button id={'buttonToggle' + this.props.id} size={this.props.size ? this.props.size : 'sm'}
                    className={this.props.className + ' ' + this.props.classNameTrue + ' ' + this.props.classNameFalse}
                    color={active ? this.props.colorTrue : this.props.colorFalse}
                    onClick={this.onToggle}
                >
                    <i className={'fas fa-' + (active ? this.props.iconTrue : this.props.iconFalse)} aria-hidden></i>
                </Button>
                <UncontrolledTooltip placement="top" target={'buttonToggle' + this.props.id}>
                    {active ? this.props.textTrue : this.props.textFalse}
                </UncontrolledTooltip>
            </React.Fragment>
        )
    }

    onToggle = () => this.setState({ active: !this.state.active }, () => {
        if (this.props.onClick) {
            this.props.onClick();
        }
    });
}

ButtonActionToggle.defaultProps = {
    colorTrue: 'success',
    iconTrue: 'check',
    textTrue: t('common:Activate'),

    colorFalse: 'warning',
    iconFalse: 'times',
    textFalse: t('common:De-activate')
}

export default ButtonActionToggle;